import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { DetailTradeDrillPage } from './detail-trade-drill-page'


export function DetailTradeLandingPage() {
  return (
    <PageLayout>
      <DetailTradeDrillPage />
    </PageLayout>
  )
}
